import {
  IconAccessible,
  IconActivityHeartbeat,
  IconClipboardData,
  IconClipboardList,
  IconHome,
  IconMap2,
  IconPlayCard3,
  IconReportMedical,
  IconUsers,
  type TablerIcon,
} from "@tabler/icons-react";

/**
 * The Tabler icon names a StatTile may request, matching
 * content/config.py's STAT_TILE_ICONS exactly — an addition on one side
 * with nothing on the other is either a validation gap or a silently
 * blank icon.
 */
export const STAT_TILE_ICONS: Record<string, TablerIcon> = {
  home: IconHome,
  "activity-heartbeat": IconActivityHeartbeat,
  "report-medical": IconReportMedical,
  "map-2": IconMap2,
  users: IconUsers,
  "clipboard-list": IconClipboardList,
  "clipboard-data": IconClipboardData,
  accessible: IconAccessible,
  "play-card-3": IconPlayCard3,
};
